export default __webpack_public_path__ + "static/media/Base_Daily_News.88a24468.png";